import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cplbsqicon",
  "use": "icon-cplbsqicon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cplbsqicon\">\r\n<g id=\"icon-cplbsqicon_&#230;&#148;&#182;&#232;&#181;&#183;\">\r\n<path id=\"icon-cplbsqicon_&#230;&#148;&#182;&#232;&#181;&#183;_2\" d=\"M0 7H16V9H0V7Z\" fill=\"#25272A\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol